import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import moneyFormat from '../functions/moneyFormat';
import RowEditIcon from './RowEditIcon';
import eyeIcon from '../../svgs/eye-details-icon.svg'; 
import decimalToPercent from '../functions/decimalToPercent'; 
import PageTooltip from './PageTooltip';
import { TableCell } from '@mui/material';

// pass row object and edit flag as props 
const RebateSetupRow = ({ row, count, tableHeader, enableEdit,stickyEnabled }) =>{
    // get context variables from parent 
    const {
        editRebateSetupModal, 
        setEditRebateSetupModal, 
        editRebateSetupRow, 
        setEditRebateSetupRow,
        showAdditionalDetailsModal, 
        setShowAdditionalDetailsModal, 
        additionalDetailsRow, 
        setAdditionalDetailsRow,
        rebateInputTypeId,
    } = useContext(PageContext);

    // event handler for edit click 
    const onEditClick = () =>{
        // make EditRebateSetupModal visible using state from parent 
        setEditRebateSetupModal(editRebateSetupModal => editRebateSetupModal = true);
        // pass current row to EditRebateSetupModal using context variable
        setEditRebateSetupRow(editRebateSetupRow => editRebateSetupRow = row);
    }

    // event handler for view click 
    const onViewClick = () => {
        // make AdditionalDetailsModal visible using state from parent
        setShowAdditionalDetailsModal(showAdditionalDetailsModal => showAdditionalDetailsModal = true); 
        // pass current row to AdditionalDetailsModal using context variable
        setAdditionalDetailsRow(additionalDetailsRow => additionalDetailsRow = row); 
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    // show red icon for disabled (0) status or green icon for Active (1) status 
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    return(
        <> 
            {/* map logic over all columns in row object */}
            {tableHeader.map(el =>
                // apply statusIcon function to status column 
                el['columnname'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                // apply moneyFormat to TierMin and TierMax columns 
                : el['columnname'] == 'minspend' || el['columnname'] == 'maxspend' ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                // show edit icon for last row 
                : el['columnname'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        {/* show edit icon to trigger EditSubCompanyRow modal */}                      
                        <RowEditIcon enable={enableEdit} onClick={onEditClick}/>
                    </TableCell> 
                // show magnifying glass icon 
                : el['columnname'] == 'additionaldetails' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} style={{ textAlign: 'center'}}>
                        {/* magnifying glass icon to trigger additional details modal */}
                        <PageTooltip title='view'>
                            <img src={eyeIcon} style={{margin: 'auto'}} className='data-table-icon-center' onClick={(e)=>onViewClick(e)}/>
                        </PageTooltip>
                    </TableCell>
                // convert to percent if rebateInputTypeId is 1
                : rebateInputTypeId == 1 && el['columnname'] == 'incentiverate' && row[el['columnname']] != null ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{decimalToPercent(row[el['columnname']])}</TableCell>
                // standard display for other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
        </>
    );
}

export default RebateSetupRow;